<template>
  <div>
    <RouteBack
      v-if="$route.params.from === 'account'"
      class="background-color-white"
    />
    <div class="background-color-white pl-4 mb-3">Support</div>
    <SupportContent />
  </div>
</template>

<script>
import RouteBack from "@/components/UI/RouteBack.vue";
import SupportContent from "@/components/Support/Content.vue";

export default {
  name: "SupportView",
  components: { RouteBack, SupportContent },
};
</script>
